"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const moment_1 = __importDefault(require("moment"));
const react_i18next_1 = require("react-i18next");
const string_utils_1 = require("@/common/string_utils");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const _1 = require(".");
function default_1({ listItem }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { is_reward, is_withdraw, upd_time, amount, is_processed, is_approved, reject_reason } = listItem;
    const listTitle = is_reward
        ? t('사비지킴이 접수')
        : is_withdraw
            ? t('정산 접수')
            : t('제작비 접수');
    const registerDate = (0, moment_1.default)(upd_time).format('YYYY-MM-DD. HH:mm');
    const settlementAmount = (0, string_utils_1.money)(amount);
    const isSettlementExpected = !is_processed && !is_approved;
    const isSettlementDenied = is_processed && !is_approved;
    const isSettlementApproved = is_processed && is_approved;
    const isBalanceSettlement = is_withdraw && !is_reward;
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            columnGap: '12px',
            padding: maxWidth768 ? '16px 0' : '16px 8px',
        } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', flexDirection: 'column', rowGap: '6px' } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', alignItems: 'center', columnGap: '8px', flexWrap: 'wrap' } }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle4 gray-80" }, { children: listTitle })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-40" }, { children: registerDate }))] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle4 gray-80" }, { children: settlementAmount }))] })), isSettlementExpected && ((0, jsx_runtime_1.jsx)(_1.SettlementExpectedButton, { is_withdraw: is_withdraw, upd_time: upd_time })), isSettlementDenied && ((0, jsx_runtime_1.jsx)(_1.SettlementDeniedButton, { isBalanceSettlement: isBalanceSettlement, reject_reason: reject_reason })), isSettlementApproved && ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle4", css: { color: 'var(--success-main)' } }, { children: `${t('정산 완료')} 🎉` })))] })));
}
exports.default = default_1;
